import path from 'path-to-regexp';
import client from '@/api/client';

function actionGenerator(method, endpoint, constants) {
  return function actionGenerated({ commit }, payload) {
    const url = path.compile(endpoint)(payload);

    let data = {
      ...payload,
    };

    if (method === 'get') {
      data = { params: data };
    }

    commit(constants.start);

    return new Promise((resolve, reject) => {
      client[method](url, data)
        .then((response) => {
          commit(constants.success, response);
          resolve(response);
        })
        .catch((error) => {
          commit(constants.failure, error);
          reject(error);
        });
    });
  };
}

function filterActionGenerator(constants) {
  return function filterAction({ commit }, payload) {
    commit(constants.filter, payload);
  };
}

function clearActionGenerator(constants) {
  return function clearAction({ commit }, options) {
    if (constants[options.action] && constants[options.action].clear) {
      commit(constants[options.action].clear);
    }
  };
}

export default function action(endpoints, constants, methods) {
  const actions = {};

  ['create', 'read', 'update', 'delete', 'list'].forEach((key) => {
    actions[key] = actionGenerator(
      methods[key],
      endpoints[key],
      constants[key],
    );
  });

  actions.filter = filterActionGenerator(constants.list);
  actions.clear = clearActionGenerator(constants);

  return actions;
}
